import { onlyNumbers } from '@/utils/format';

import { MonetaryOptions } from './types';

const defaults = (): MonetaryOptions => ({
  prefix: 'R$ ',
  suffix: '',
  thousands: '.',
  decimal: ',',
  precision: 2,
});

const normalizePrecision = (precision: number) => {
  const minValue = 0;
  const maxValue = 20;

  return Math.max(minValue, Math.min(precision, maxValue));
};

const numbersToCurrency = (numbers: string, precision: number) => {
  const exp = 10 ** precision;
  let float = parseFloat(numbers) / exp;
  if (Number.isNaN(float)) float = 0;
  return float.toFixed(normalizePrecision(precision));
};

const splitIntegerAndDecimal = (value: string) => value.split('.');

const addThousandSeparator = (integer: string, separator: string) =>
  integer.replace(/\B(?=(\d{3})+(?!\d))/g, separator);

const joinIntegerAndDecimal = (integer: string, decimal: string, separator: string) =>
  `${integer}${separator}${decimal}`;

export const monetaryFormat = (input: string | number, options: Partial<MonetaryOptions> = defaults()) => {
  const { precision, decimal, thousands, suffix, prefix } = { ...defaults(), ...options };
  let output = input ?? '';

  if (typeof output === 'number') output = output.toFixed(normalizePrecision(precision));

  const negative = output.indexOf('-') >= 0 ? '-' : '';
  const numbers = onlyNumbers(output);
  const currency = numbersToCurrency(numbers, precision);
  const [naturals, decimals] = splitIntegerAndDecimal(currency);
  const integer = addThousandSeparator(naturals, thousands);
  const decimalJoin = joinIntegerAndDecimal(integer, decimals, decimal);

  return `${prefix}${negative}${decimalJoin}${suffix}`;
};
